import React from 'react';
import { withStyles } from '@material-ui/core';
import { ContentContainer } from '@/components/Cards/ContentContainer';
import EmailsContextProvider from '@/contexts/Emails/context';
import styles from './styles';
import TitanMailPageWrapper from './TitanMailPageWrapper';

const TitanMail = ({ classes }) => (
  <ContentContainer className={classes.root}>
    <EmailsContextProvider>
      <TitanMailPageWrapper />
    </EmailsContextProvider>
  </ContentContainer>
);

export default withStyles(styles)(TitanMail);
